import styled from "styled-components";
import { Button } from "antd";

export const AntdButton = styled(Button)`
  width: 104px;
  height: 104px;
`;
